import * as React from 'react';
import classnames from 'classnames';
import useBreakpoint, { breakpoints } from '@root/shared/useBreakpoint';
import s from './OnlyIn.module.less';

type Props = {
  children: React.ReactNode;
  className?: string;
  preventRendering?: boolean;
};

const OnlyInMobile = ({ children, className, preventRendering = false }: Props) => {
  const breakpoint = useBreakpoint();

  if (preventRendering && breakpoint !== breakpoints.MOBILE) {
    return null;
  }

  return <div className={classnames(className, s.mobileOnly)}>{children}</div>;
};

export default OnlyInMobile;
